export const MOONBASE_ADDRESS = '0x34Ea289f45DD34fcD5bAea6fe8632f5CB69dd5d9'; //New Cheap
export const MOONBEAM_ADDRESS = '0xe1F4703987fd6Abcb0358Ea9ee03A56298905309';

export const ZOOMBIES_WORLD = 'https://zoombies.info/';

export const ADMIN_ACC_1 = '0x0A90Bc3f5273545678199eA27dB9D442F19c5009'; //Ryan
export const ADMIN_ACC_2 = '0x9B9fc58A24F296D04D03921550C7fFc441aF34ba'; //zoombies
export const ADMIN_ACC_3 = '0x23dc227F2742F63425e5B088218a9f70e5ad49AE'; //AP acc 2

export const ADMINS = [ADMIN_ACC_1, ADMIN_ACC_2, ADMIN_ACC_3];